export default "__VITE_ASSET__992c8767__"